<script>
  export let label;
  export let link;
  export let flag;
  export let onClick;
  export let advance_page = false;

  export let disabled;

  import { flags, currentPageIndex, ci, layout } from "../store.js";

  const addFlag = (flag) => {
    $flags.add(flag);
    $flags = $flags;
  };

  const click = () => {
    if (flag) addFlag(flag);
    if (link) window.open(link, "_blank").focus();
    if (onClick) onClick();
    if (advance_page && layout === "fullscreen") $currentPageIndex += 1;
  };

  let fontFamily = $ci.page.button.font ?? $ci.page.body.font;
  let fontWeight = $ci.page.button.font_weight ?? "bold";
  let fontStyle = $ci.page.button.font_style ?? "normal";
  let fontSize = $ci.page.button.size ?? "1.0rem";
</script>

<div class="locked-button">
  <button
    type="button"
    {disabled}
    on:click={click}
    style="--font: {fontFamily}; --font-weight: {fontWeight}; --font-style: {fontStyle}; --font-size: {fontSize}"
  >
    {#if !label}
      <slot />
    {:else}
      {label}
    {/if}
  </button>
</div>

<style type="text/scss">
  .locked-button button {
    margin: 0.77em;
    min-width: 130px;
    height: 40px;
    color: #FAF5E7;
    padding: 5px 10px;
    font-weight: var(--font-weight);
    font-style: var(--font-style);
    font-size: var(--font-size);
    cursor: pointer;
    transition: all 0.18s ease-in-out;
    position: relative;
    display: inline-block;
    outline: none;
    border-radius: 20px;
    border: 2px solid var(--color-accent);
    background: var(--color-accent);
    font-family: var(--font);

    &:not(:disabled):hover {
      background: #FAF5E7;
      color: var(--color-accent);
    }

    &:not(:disabled):active {
      top: 2px;
    }

    &:disabled {
      cursor: unset;
      background: gray;
      border: gray;
    }
  }
</style>
